import React, { useEffect } from 'react'
import { useAuth } from 'wasp/client/auth'
import { useNavigate } from 'react-router-dom'
import { useQuery } from 'wasp/client/operations'
import * as ops from 'wasp/client/operations'
// AppFrame removed: route-level layout wraps admin pages
import { Card } from '../../components/ui/card'

export function AdminAI() {
  const { data: user } = useAuth()
  const navigate = useNavigate()
  const isAdmin = Boolean((user as any)?.isAdmin)
  useEffect(() => { if (user && !isAdmin) navigate('/') }, [user, isAdmin])
  const { data, isLoading, error } = useQuery(ops.getAdminMetrics as any, { preset: 'ai' } as any, { enabled: isAdmin })
  if ((error as any)?.message?.includes('403')) {
    return <div className="p-6 text-red-600">Access denied: admin only.</div>
  }
  if (isLoading) return (
      <div className="space-y-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-martinique dark:text-white">AI Configuration</h1>
          <p className="text-martinique/70 dark:text-white/70 mt-2">Loading AI metrics and costs...</p>
        </div>
        <div className="animate-pulse space-y-6">
          <div className="h-32 bg-stone dark:bg-darkcard rounded-xl"></div>
          <div className="h-32 bg-stone dark:bg-darkcard rounded-xl"></div>
        </div>
      </div>
  )
  
  return (
      <div className="space-y-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-martinique dark:text-white">AI Configuration</h1>
          <p className="text-martinique/70 dark:text-white/70 mt-2">Token usage, costs, and AI provider metrics</p>
        </div>

        {/* Spoonacular status mini-panel */}
        <SpoonacularStatusPanel enabled={isAdmin} />
        
        <Card className="p-8 bg-sand dark:bg-darkcard border-0 rounded-xl shadow-card">
          <div className="text-xl font-medium text-martinique dark:text-white mb-6">AI Metrics & Configuration</div>
          <div className="bg-lynx dark:bg-martinique rounded-lg p-6">
            <pre className="text-sm text-martinique/80 dark:text-white/80 overflow-auto whitespace-pre-wrap font-mono">{JSON.stringify(data, null, 2)}</pre>
          </div>
        </Card>
      </div>
  )
}

export default AdminAI

function SpoonacularStatusPanel({ enabled }: { enabled: boolean }) {
  const hasOp = typeof (ops as any)?.getSpoonacularStatus === 'function'
  if (!hasOp) return null
  const { data: spoonData, isLoading, error } = useQuery(
    (ops as any).getSpoonacularStatus,
    {},
    { enabled },
  ) as any
  if (error) return null
  return (
    <Card className="p-6 bg-white/70 dark:bg-darkcard border rounded-xl">
      <div className="mb-4 text-lg font-semibold">Spoonacular Status</div>
      {isLoading ? (
        <div className="animate-pulse h-8 bg-stone/50 dark:bg-martinique/50 rounded" />
      ) : (
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <div className="text-muted-foreground">Request Count</div>
            <div className="font-medium">{spoonData?.usage?.requestCount ?? 0}</div>
          </div>
          <div>
            <div className="text-muted-foreground">Remaining</div>
            <div className="font-medium">{spoonData?.usage?.remaining ?? 0}</div>
          </div>
          <div>
            <div className="text-muted-foreground">Percent Used</div>
            <div className="font-medium">{spoonData?.usage?.percentUsed ?? 0}%</div>
          </div>
          <div>
            <div className="text-muted-foreground">Breaker</div>
            <div className="font-medium">{spoonData?.fallback?.breaker?.state ?? 'CLOSED'}</div>
          </div>
          <div>
            <div className="text-muted-foreground">Breaker Failures</div>
            <div className="font-medium">{spoonData?.fallback?.breaker?.failureCount ?? 0}</div>
          </div>
          <div>
            <div className="text-muted-foreground">Memo Cache Size</div>
            <div className="font-medium">{spoonData?.fallback?.memoSize ?? 0}</div>
          </div>
        </div>
      )}
    </Card>
  )
}
